import { createApp } from 'vue'
// components
import PricesAndPromo from './vue/PricesAndPromo.vue'
import FiltersShoulder from './vue/FiltersShoulder.vue'
import UserActivity from "./vue/UserActivity/UserActivity.vue";
import QuantityDiscount from "./vue/quantityDiscount/QuantityDiscount.vue";

const priceAndPromoEl = document.querySelector('#prices-and-promo');
if (priceAndPromoEl) {
    const priceAndPromoComp = createApp({})
    priceAndPromoComp.component('prices-and-promo', PricesAndPromo)
    priceAndPromoComp.component('filters-shoulder', FiltersShoulder)
    priceAndPromoComp.mount(priceAndPromoEl)
}

document.querySelectorAll('.vue-collection-promo-instance').forEach((el) => {
    const defaultCompanyId = parseInt(el.dataset.defaultCompanyId);
    if (!isNaN(defaultCompanyId)) {
        const initialFilters = JSON.parse(el.dataset.initialFilters || '{}');
        const onlyComponent = el.dataset.onlyComponent === 'true';
        const instanceId = el.dataset.instanceId;

        createApp(PricesAndPromo, {
            defaultCompanyId: defaultCompanyId,
            initialFilters,
            onlyComponent,
            instanceId
        }).mount(el);
    }
});

const userActivityEl = document.querySelector('#user-activity');
if (userActivityEl) {
    createApp(UserActivity).mount(userActivityEl)
}

const quantityDiscountEl = document.querySelector('#quantity-discount');
if (quantityDiscountEl) {
    createApp(QuantityDiscount, {
        defaultCompanyId: parseInt(quantityDiscountEl.dataset.defaultCompanyId)
    }).mount(quantityDiscountEl)
}
